/*
 * Angel Twin Terms and Conditions Page
 */
import React, { useEffect, useState, Suspense, lazy } from 'react';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import "./index.css";
import axios from 'axios';
import parser from 'html-react-parser';
import termsjsonData from "./termsandconditions.json";

const Footer = lazy(() => import("../FooterNewChanges/FooterNewChanges"));

const AngelTwinTermsAndConditions = () => {
  const [termsAndConditionsData, setTermsAndConditionsData] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    /**
     * Fetch terms and conditions data with local JSON fallback
     */
    const fetchTermsAndConditions = async () => {
      try {
        // Attempt to fetch from API
        const response = await axios.post(
          process.env.REACT_APP_TERMS_AND_CONDITIONS, 
          { websiteName: 'myanglai.com' }
        );
        
        // If API call successful, set the data
        if (response.data && response.data.data) {
          setTermsAndConditionsData(response.data.data);
        } else {
          // Fallback to local JSON if API response is invalid
          setTermsAndConditionsData(termsjsonData["myanglai.com"]);
        }
      } catch (error) {
        // If API call fails, use local JSON
        console.warn('Failed to fetch terms and conditions from API. Using local JSON.', error);
        setTermsAndConditionsData(termsjsonData["myanglai.com"]);
      }
    };

    fetchTermsAndConditions();
  }, []);
 
  return (
    <article>
      <div className='terms-conditions-container'>
      <div className="terms-banner" style={{ backgroundColor: "rgb(2, 3, 53)" }}>
        {/* Video Section */}
        <video
          className="banner-video"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        >
          <source
            src={
              process.env.REACT_APP_CDN_LINK +
              (isMobile
                ? "angeltwin/banner-video-mobile.mp4"
                : "angeltwin/banner-video-desktop.mp4")
            }
            type="video/mp4"
          />
        </video>
        
        {/* Content Section */}
        <Container style={{zIndex: "2"}}>
          <Row>
            <Col>
              <div>
                <h1 className="terms-heading">Terms of Service</h1>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      
      <Container>
        {termsAndConditionsData ? (
          <Row className="termsRow">
            <Col md={12} className="angelaidisclaimer pt-5">
              {termsAndConditionsData.angelaidisclaimer.map((disclaimer, i) => (
                <p key={i}>
                  {parser(disclaimer)}
                </p>
              ))}
            </Col>
            
            {termsAndConditionsData.termsAndConditions.map((termsItem, j) => (
              <Col md={12} key={j}>
                <div className="terms_header" />
                <div className="license_content">
                  {/* Render heading without numbers */}
                  <p className="heading">{parser(termsItem.heading)}</p>
                  
                  {/* Render description paragraphs */}
                  {termsItem.description.map((descriptionData, k) => (
                    <p key={k}>
                      {parser(descriptionData)}
                    </p>
                  ))}
                </div>
              </Col>
            ))}
          </Row>
        ) : (
          <Row>
            <Col className="text-center py-5">
              <p>Loading terms and conditions...</p>
            </Col>
          </Row>
        )}
      </Container>
      
      <div className='mt-4'>
         <Suspense fallback={<div />}>
          <Footer />
        </Suspense> 
      </div>
      </div>
    </article>
  );
};

export default AngelTwinTermsAndConditions;